<script setup lang="ts">

import type { IMyGarageViewModel } from '@app/MyGarage';
import { useAppConfiguration } from "@domain/AppConfiguration";
import { useUserSettings } from "@services/UserSettings";

const model = defineModel<IMyGarageViewModel>( { required: true } );  
const app = useAppConfiguration();
const settings = useUserSettings();

</script>

<template>

    <div class="grid grid-cols-2 items-center justify-evenly gap-3 px-4 3xl:px-6"
        :class="settings.expandProfileActions ? 'pt-6' : 'pt-0'"> 

        <!-- <Button v-if="settings.expandProfileActions && app.isGeneric == false" 
                variant="tonal" 
                class="!h-10 lg:!h-12 3xl:!h-14 !px-0 !min-w-0 overflow-hidden rounded-lg"
                to="/my-garage/digital-service-log">
            <Icon name="dashboard:service" class="collapse md:visible text-xl 3xl:text-2xl mr-1 lg:mr-1.5" />
            <span class="3xl:text-base">Service Log</span> 
        </Button>

        <Button v-if="settings.expandProfileActions && app.isGeneric == false" 
                variant="tonal" 
                class="!h-10 lg:!h-12 3xl:!h-14 !px-0 !min-w-0 overflow-hidden rounded-lg"
                to="/my-garage/history">
            <Icon name="history" class="collapse md:visible text-xl 3xl:text-2xl mr-1 lg:mr-1.5" />
            <span class="3xl:text-base">History</span>
        </Button> -->
        
        <Button v-if="settings.expandProfileActions && model.carePlan.showReminders" 
                variant="tonal" 
                class="!h-10 lg:!h-12 3xl:!h-14 !px-0 !min-w-0 overflow-hidden rounded-lg"
                to="/my-garage/condition-settings">
            <Icon name="settings-levers" class="collapse md:visible text-xl 3xl:text-2xl mr-1 lg:mr-1.5" />
            <span class="3xl:text-base">Conditions</span>
        </Button>

        <Button v-if="settings.expandProfileActions" 
                variant="tonal" 
                class="!h-10 lg:!h-12 3xl:!h-14 !px-0 !min-w-0 overflow-hidden rounded-lg"
                to="/my-garage/settings">
            <Icon name="settings" class="collapse md:visible text-xl 3xl:text-2xl mr-1 lg:mr-1.5" />
            <span class="3xl:text-base">Settings</span>
        </Button>
        
    </div>
            
</template>